function removeLeadingZeroes(str) {
  return str.replace(/^0\.*0*/g, '')
}

function formatDecimal(str) {
  return str.replace(/(\d{2}$)/g, '.$1')
}

function removeDecimal(str) {
  return str.replace(/\./g, '')
}

export default {
  update(el, { value, oldValue }) {
    const val = `${parseFloat(value)}`
    const event = new Event('input', { bubbles: true })

    if (!isNaN(val)) {
      if (val === '0') {
        el.value = '0'
      } else {
        const x = removeDecimal(removeLeadingZeroes(val))
        switch (x.length) {
          case 1:
            el.value = `0.0${x}`
            break
          case 2:
            el.value = `0.${x}`
            break
          default:
            el.value = formatDecimal(removeDecimal(x))
        }
      }
    } else {
      el.value = ''
    }
    if (el.value !== oldValue) {
      el.dispatchEvent(event)
    }
  }
}
